import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  padding: 0;
  background: #fff;
  min-height: 85vh;
  height: 100%;
  .succes-pop-up {
    width: 40%;
    border: 1px solid gray;
    border-radius: 25px;
    margin: auto;
    padding: 3rem;
    text-align: center;
    p {
      margin: 2rem 0;
    }
  }
  .packages-section {
    width: 90%;
    margin: 1rem auto;
    h2 {
      text-align: center;
    }
  }
  .popup-container {
    width: 100vw;
    height: 100vh;
    position: fixed;
    z-index: 10;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    h3 {
      text-align: center;
    }
    .form-container {
      background: #fff;
      width: 50%;
      form {
        width: 90%;
        margin: 0 auto;
        .form-group {
          display: flex;
          flex-direction: column;
          input {
            padding: 1rem;
            margin: 1rem 0;
            border-radius: 14px;
            border: 1px solid #cccccc;
          }
          &.buttons {
            flex-direction: row;
          }
        }
        .personal-container {
          display: flex;
          flex-direction: column;
          width: 100%;
          .buyer-name {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
          }
          .messagge input {
            height: 100px;
          }
        }
      }
    }
  }

  @media screen and (max-width: 867px) {
    margin: 0 auto;
    .popup-container {
      .form-container {
        width: 90%;
      }
    }
  }
`;
